import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { DialogHeader } from '@/components/dialog/dialog-header';
/** Confirms restoring queue / inbound availability ("return to service" — not labeled as unpause). */
export default function ReturnToServiceDialog({ visible, onHide, onConfirmReturnToService, }) {
    const [submitting, setSubmitting] = useState(false);
    const handleConfirm = useCallback(async () => {
        setSubmitting(true);
        try {
            await onConfirmReturnToService();
            onHide();
        }
        catch {
            /* Caller shows toast */
        }
        finally {
            setSubmitting(false);
        }
    }, [onConfirmReturnToService, onHide]);
    return (_jsx(Dialog, { header: _jsx(DialogHeader, { icon: "pi pi-headphones", label: "Return to service" }), visible: visible, modal: true, draggable: false, resizable: false, dismissableMask: true, style: { width: '96vw', maxWidth: '28rem' }, onHide: onHide, footer: _jsxs("div", { className: "flex justify-content-end gap-2", children: [_jsx(Button, { type: "button", label: "Stay on break", severity: "secondary", text: true, disabled: submitting, onClick: onHide }), _jsx(Button, { type: "button", label: "Return to service", loading: submitting, disabled: submitting, onClick: () => void handleConfirm() })] }), children: _jsx("p", { className: "m-0 text-900 line-height-3", children: "You will register for incoming queue calls again. Confirm when you are ready to receive calls?" }) }));
}
